import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { registerError } from "redux/modules/errors/actions";
import { actions } from "./model";
import { MOCK_BLOCKS } from "./constants";
import { renderToString } from "react-dom/server";
import { MediumFilledButton } from "components/Base";
import React from "react";
import { actions as portalHomeActions } from "../../PortalHome/model";
import { apiCall } from "App/Data/sagas";

const processBlocks = blocks =>
  blocks.map(block => {
    if (block.type === "h1") {
      return {
        ...block,
        value: `<h1>${block.value}</h1>`
      };
    } else if (block.type === "h2") {
      return {
        ...block,
        value: `<h2>${block.value}</h2>`
      };
    } else if (block.type === "h3") {
      return {
        ...block,
        value: `<h3>${block.value}</h3>`
      };
    } else if (block.type === "text") {
      return {
        ...block,
        value: `<p>${block.value}</p>`
      };
    } else if (block.type === "button") {
      const buttonHtml = renderToString(
        <MediumFilledButton bg="primary7" style={{ margin: "1rem 0" }}>
          <div dangerouslySetInnerHTML={{ __html: block.value }} />
        </MediumFilledButton>
      );
      return {
        ...block,
        value: buttonHtml
      };
    } else if (block.type === "image") {
      return {
        ...block,
        value: `<img src="${block.value}" alt="image" style="width: 100%; height: auto; object-fit: contain" />`
      };
    } else if (block.type === "divider") {
      return {
        ...block,
        value: `<hr/>`
      };
    } else {
      return block;
    }
  });

const init = function*({ payload: { resourceId } }) {
  try {
    yield put(actions.setLoading(true));

    const { payload: pagePayload } = yield call(apiCall, {
      method: "get",
      url: `/sites/site/portal/page/${resourceId}`
    });

    if (pagePayload.blocks) {
      yield put(
        actions.setBlocksContent({
          blocks: processBlocks(MOCK_BLOCKS)
        })
      );
    } else {
      yield put(
        actions.setPageContent({
          title: pagePayload.details.title,
          subtitle: pagePayload.details.subtitle,
          content: pagePayload.details.content
        })
      );
    }

    yield put(actions.setLoading(false));
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred while fetching data"
        }
      ])
    );
  }
};

const goHome = function*() {
  yield put(portalHomeActions.goHomeFromWikiPage());
};

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const watchGoHome = function*() {
  yield takeEvery(actions.goHome.type, goHome);
};

const rootSaga = function*() {
  yield all([fork(watchInit), fork(watchGoHome)]);
};

export default rootSaga;
